const EventEmitter = require('events')
export const EventSystem = new EventEmitter()